import React, { useCallback } from 'react';
import { NewContactFormCreate } from '../../../features/user/journalist/newContact/NewContactFormContainer';
import { useHistory } from 'react-router';
import { APP_ROUTES } from '../../../routing/AppRoutes';

export const CreateNewGuest: React.FC = () => {
  const history = useHistory();
  const gotToUploadMedia = useCallback(() => {
    history.push(APP_ROUTES.FN_UPLOAD_GUEST_MEDIA());
  }, [history]);

  return <NewContactFormCreate onSuccess={gotToUploadMedia} />;
};
